import 'core-js/features/symbol'

// IE helper function to support remove()
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/ie-polyfill.js